import React from 'react';
import { SimpleRegistration, SimpleRegistrationErrors } from '../types';

interface SimpleRegistrationFormProps {
  formData: Partial<SimpleRegistration>;
  errors: SimpleRegistrationErrors;
  isSubmitting: boolean;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (e: React.FormEvent) => void;
}

const SimpleRegistrationForm: React.FC<SimpleRegistrationFormProps> = ({
  formData,
  errors,
  isSubmitting,
  onInputChange,
  onSubmit
}) => {
  return (
    <div className="uk-card uk-card-default uk-card-body uk-border-rounded uk-width-1-1 uk-width-1-2@m uk-margin-auto">
      <div className="uk-text-center uk-margin-medium-bottom">
        <h2 className="uk-heading-small uk-margin-remove">Registro de Empresa</h2>
        <p className="uk-text-muted uk-margin-small-top">
          Crea tu cuenta para acceder a BuenAire
        </p>
      </div>

      <form onSubmit={onSubmit} className="uk-form-stacked">
        {/* Error general */}
        {errors.general && (
          <div className="uk-alert-danger uk-margin-small-bottom" data-uk-alert>
            <button className="uk-alert-close" data-uk-close type="button" aria-label="Cerrar alerta"></button>
            <p>{errors.general}</p>
          </div>
        )}

        {/* Nombre Completo */}
        <div className="uk-margin-small">
          <label className="uk-form-label" htmlFor="fullName">
            Nombre Completo *
          </label>
          <div className="uk-form-controls">
            <input
              className={`uk-input ${errors.fullName ? 'uk-form-danger' : ''}`}
              id="fullName"
              name="fullName"
              type="text"
              placeholder="Tu nombre completo"
              value={formData.fullName || ''}
              onChange={onInputChange}
              required
              style={{ color: '#333', backgroundColor: '#fff' }}
            />
            {errors.fullName && (
              <div className="uk-text-danger uk-text-small uk-margin-small-top">
                {errors.fullName}
              </div>
            )}
          </div>
        </div>

        {/* Email */}
        <div className="uk-margin-small">
          <label className="uk-form-label" htmlFor="email">
            Email *
          </label>
          <div className="uk-form-controls">
            <input
              className={`uk-input ${errors.email ? 'uk-form-danger' : ''}`}
              id="email"
              name="email"
              type="email"
              placeholder="tu@empresa.com"
              value={formData.email || ''}
              onChange={onInputChange}
              required
              style={{ color: '#333', backgroundColor: '#fff' }}
            />
            {errors.email && (
              <div className="uk-text-danger uk-text-small uk-margin-small-top">
                {errors.email}
              </div>
            )}
          </div>
        </div>

        {/* Contraseña */}
        <div className="uk-margin-small">
          <label className="uk-form-label" htmlFor="password">
            Contraseña *
          </label>
          <div className="uk-form-controls">
            <input
              className={`uk-input ${errors.password ? 'uk-form-danger' : ''}`}
              id="password"
              name="password"
              type="password"
              placeholder="Mínimo 3 caracteres"
              value={formData.password || ''}
              onChange={onInputChange}
              required
              style={{ color: '#333', backgroundColor: '#fff' }}
            />
            <div className="uk-text-muted uk-text-small uk-margin-small-top">
              Mínimo 3 caracteres
            </div>
            {errors.password && (
              <div className="uk-text-danger uk-text-small uk-margin-small-top">
                {errors.password}
              </div>
            )}
          </div>
        </div>

        {/* Confirmar Contraseña */}
        <div className="uk-margin-small">
          <label className="uk-form-label" htmlFor="confirmPassword">
            Confirmar Contraseña *
          </label>
          <div className="uk-form-controls">
            <input
              className={`uk-input ${errors.confirmPassword ? 'uk-form-danger' : ''}`}
              id="confirmPassword"
              name="confirmPassword"
              type="password"
              placeholder="Repite tu contraseña"
              value={formData.confirmPassword || ''}
              onChange={onInputChange}
              required
              style={{ color: '#333', backgroundColor: '#fff' }}
            />
            {errors.confirmPassword && (
              <div className="uk-text-danger uk-text-small uk-margin-small-top">
                {errors.confirmPassword}
              </div>
            )}
          </div>
        </div>

        {/* Botón de envío */}
        <div className="uk-margin-medium-top uk-text-center">
          <button
            type="submit"
            className="uk-button uk-button-primary uk-button-large uk-width-1-1"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <span className="uk-margin-small-right" data-uk-spinner="ratio: 0.8"></span>
                Registrando...
              </>
            ) : (
              <>
                <i className="fas fa-user-plus uk-margin-small-right"></i>
                Crear Cuenta
              </>
            )}
          </button>
        </div>

        {/* Enlace a login */}
        <div className="uk-text-center uk-margin-medium-top">
          <p className="uk-text-small uk-text-muted">
            ¿Ya tienes una cuenta?{' '}
            <button type="button" className="uk-link uk-button-text" onClick={() => {/* TODO: Implementar navegación a login */}}>
              Inicia sesión aquí
            </button>
          </p>
        </div>
      </form>
    </div>
  );
};

export default SimpleRegistrationForm;
